<template>
  <div class="checkClothCount">
      <navbar title="总检查询"></navbar>
      <div class="flex1 workload flex-column h100">
        <!--顶部选项-->

        <el-card class="box-card">

            <div class="inblock">
                <!--门店选择-->
                <span>请选择门店：</span>
                <div class="inblock m-left time">
                    <el-select v-model="StoreSingleData.shop_id" @change="StoreSingleChange" placeholder="--请选择门店--">
                        <el-option
                            v-for="(item,index) in allShop"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

             <div class="inblock time">
                统计日期:
                <el-date-picker
                    v-model="time"
                    @change="DateChange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </div>
        </el-card>

        <div class="flex1 mt10">
            <el-table
                :data="StoreSingleListData.list"
                border
                style="width: 100%"
                :height="tableHeight"
                :row-class-name="tableRowClassName">
                <el-table-column prop="mall_product_name" label="名称" sortable></el-table-column>
                <el-table-column prop="shopName" label="门店" sortable></el-table-column>
                <el-table-column prop="code_num" label="条形码"></el-table-column>
                <el-table-column prop="create_time" label="时间"></el-table-column>
                <el-table-column prop="cloth_status" label="状态"></el-table-column>
          
            </el-table>
        </div>

        <el-card v-if="isShowPagination" class="box-card1">
          <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="StoreSingleData.page"
                :page-size.sync="StoreSingleData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="StoreSingleListData.info.count"
                background
            ></el-pagination>
          </div>
        </el-card>
        

      </div>
  </div>
</template>

<script>
  import header from '@/components/header'

  export default {
    components: {
      navbar: header
    },
    data() {
       return {
        time: [new Date(), new Date()],
        tableHeight: window.innerHeight - 200,
        allShop: [],
        StoreSingleListData: [],
        isShowPagination: false,
        StoreSingleData: {
            shop_id: '',
            startTime: '',
            endTime: '',
            page: 1,
            limit: 10
        }
       }
    },
    created() {
        this.time[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
        this.time[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');

        this.getAllShop();
    },
    methods: {
        // 分页大小变化
        handleSizeChange(val) {
            this.StoreSingleData.limit = val;
            this.StoreSingleChange()
        },

        // 当前页变化
        handleCurrentChange(val) {
            console.log("当前页变化: ", val)
            this.StoreSingleData.page = val;
            this.StoreSingleChange()
        },

        // 下拉地址选择的时候
        StoreSingleChange() {
            console.log("StoreSingleData.shop_id: ", this.StoreSingleData.shop_id)
            this.StoreSingleData.startTime = this.time[0]
            this.StoreSingleData.endTime = this.time[1]
            this.StoreSingleGetData()
        },
        // 时间选择的时候
        DateChange() {
            this.StoreSingleData.startTime = this.time[0]
            this.StoreSingleData.endTime = this.time[1]
            this.StoreSingleGetData()
        },
        // getAllShop() {},
         // 获取所有门店数据 
        async getAllShop() {
            this.allShop = (await this.$http.allShop()).data.data;
        },
        /**
         * 请求单个门店工厂总检数据查询
         */
         async StoreSingleGetData() {
            this.StoreSingleListData = await (await this.$http.checkClothCount(this.StoreSingleData)).data.data
            console.log("this.StoreSingleListData: ", this.StoreSingleListData)
            if (this.StoreSingleListData.list.length !== 0) {
                this.isShowPagination = true
            } else {
                this.isShowPagination = false
            }
        },
        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 == 0) {
                return 'warning-row';
            }
            return '';
        }
    },
  }
</script>

<style scoped>
.time {
    margin-left: 30px;
}
</style>